import { Tabs as TabsPrimitive } from 'radix-ui';
import * as React from 'react';
import { cn } from '../../lib/cn.js';

export const Tabs = TabsPrimitive.Root;

export const TabsList = React.forwardRef<HTMLDivElement, React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>>(function TabsList(
  { className, ...props },
  ref,
) {
  return (
    <TabsPrimitive.List
      ref={ref}
      className={cn('flex max-w-full items-end gap-1 overflow-x-auto border-b border-border-subtle', className)}
      {...props}
    />
  );
});

/** Active tab: dark text + 2px underline (not color-only). */
export const TabsTrigger = React.forwardRef<HTMLButtonElement, React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>>(
  function TabsTrigger({ className, ...props }, ref) {
    return (
      <TabsPrimitive.Trigger
        ref={ref}
        className={cn(
          '-mb-px inline-flex h-10 items-center gap-1.5 whitespace-nowrap border-b-2 border-transparent px-3 text-body font-medium text-text-secondary transition-colors',
          'hover:text-text-primary focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-focus',
          'data-[state=active]:border-brand-primary data-[state=active]:text-text-primary',
          'disabled:opacity-50 [&_svg]:size-4',
          className,
        )}
        {...props}
      />
    );
  },
);

export const TabsContent = React.forwardRef<HTMLDivElement, React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>>(
  function TabsContent({ className, ...props }, ref) {
    return <TabsPrimitive.Content ref={ref} className={cn('mt-4 focus-visible:outline-2 focus-visible:outline-focus', className)} {...props} />;
  },
);
